export const website = {
  firstStep: {
    title: "Zaczynamy! Którego szablonu użyć?",
    subtitle:
      "Czas stworzyć efektowną stronę. Zaczynamy od szablonów, a potem przechodzimy do kolorów.",
  },
  secondStep: {
    title: "Która gama kolorów najlepiej pasuje do Pana/Pani marki?",
    subtitle: "Proszę spersonalizować szablon odrobiną koloru",
  },
  thirdStep: {
    title: "Czy są dostępne dobre zdjęcia obiektu?",
    titleLine2: "Proszę je wgrać!",
    subtitle: "Proszę wgrać najlepsze zdjęcie obiektu na stronę główną",
  },
  fourthStep: {
    title: "Świetnie. A jaka nazwa dla firmy?",
    subtitle:
      "Nazwa i hasło firmy zwiększają rozpoznawalność i wzmacniają wizerunek marki.",
  },
  fifthStep: {
    title: "Czy marka ma już logo?",
    subtitle:
      "Najlepszy efekt daje projekt wektorowy lub plik PNG z przezroczystym tłem. Idealne proporcje to 2:1 albo 1:1 (obraz kwadratowy). Rozmiar powinien wynosić 400px x 192px (min. wysokość 60px). Jeśli logo jeszcze nie ma, jako marka zostanie użyta nazwa firmy.",
  },
  livingstone: {
    navMain: "Menu główne",
    navProperty: "Obiekt",
    navMap: "Mapa",
    navGallery: "Galeria",
    navRates: "Stawki",
    navAvailability: "Dostępność",
    navReviews: "Opinie",
    bookNow: "Zarezerwuj teraz",
    checkinCheckout: "Przyjazd → Wyjazd",
    guests: "Goście",
  },
  tideway: {
    navMain: "Menu główne",
    navProperty: "Obiekt",
    navMap: "Mapa",
    navGallery: "Galeria",
    navRates: "Stawki",
    navAvailability: "Dostępność",
    navReviews: "Opinie",
    bookNow: "Zarezerwuj teraz",
    checkinCheckout: "Przyjazd → Wyjazd",
    guests: "Goście",
  },
};
